import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function Logo(props) {
  const { t } = useTranslation();

  const [dataLogo] = useState([
    // { id: 1, name: 'cheap_Coins' },
    { id: 2, name: 'safe_Coins' },
    { id: 3, name: 'trustedMarketplace' },
    { id: 4, name: 'affordableCoins' },
    { id: 5, name: 'boostTeam' },
    { id: 6, name: 'secureTransfers' },
    { id: 7, name: 'safeFutCoins' },
    { id: 8, name: 'trusted_Players' },
    { id: 9, name: 'bestPrices' },
    { id: 10, name: 'powerUpTeam' },
  ]);

  return (
    <section className="logo-slider">
      <div className="logo-slider-wrap">
        <div className="logo-slider-inner">
          {dataLogo.map((idx) => (
            <h3 key={idx.id}>{t(idx.name)}</h3>
          ))}
        </div>
        <div className="logo-slider-inner style-2">
          {dataLogo.map((idx) => (
            <h3 style={{textTransform: 'uppercase !important'}} key={idx.id}>{t(idx.name)}</h3>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Logo;
